// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aRcrnT {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  min-height: calc(100vh - 68px);
  margin-left: -24px;
  margin-right: -24px;
  width: calc(100% + 48px);
  background-color: var(--surface-neutral-white);
}

.FJTRwj {
  background-color: var(--surface-neutral-pale, #f2f2f2);
  position: relative;
  overflow: hidden;
  min-height: 840px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Qj8y7R {
  width: 100%;
  height: auto;
  max-width: none;
  flex-shrink: 0;
  object-fit: contain;
  pointer-events: none;
}

.FpybaY {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-neutral-white);
  padding: var(--spacing-3);
  gap: var(--spacing-3);
}

.zFXSTX {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 350px;
  gap: var(--spacing-3);
}

.ay8rJF {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 350px;
  gap: var(--spacing-2);
}

.UQ0zqK {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-2);
}

.CRibl_ {
  width: 32px !important;
  height: 32px !important;
  flex-shrink: 0;
}

.bGA4j2 {
  font-size: 24px;
  color: var(--text-neutral-dark);
  margin: 0;
  line-height: var(--line-height-100);
  text-align: center;
}

.v67ek_ {
  font-weight: var(--font-weight-bold);
}

.JZnUHb {
  font-weight: var(--font-weight-regular);
}

.qiSExc {
  font-size: 15px;
  color: var(--text-neutral-dark);
  line-height: var(--line-height-160);
  align-self: center;
  margin: 0;
}

.ATlYMt {
  width: 350px;
  display: flex;
  flex-direction: column;
  background-color: var(--surface-neutral-white);
}

.HZ5kc4 {
  padding: 0;
}

.lKm2Ib {
  --benefits-timeline-item-min-height: 32px;
  --benefits-timeline-item-padding-bottom: 0px;
  --benefits-timeline-connector-top: 16px;
  --benefits-timeline-connector-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/WaitingApprovalPage/WaitingApprovalPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;EACT,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,uCAAuC;EACvC,0CAA0C;AAC5C","sourcesContent":[".layoutRoot {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: stretch;\n  min-height: calc(100vh - 68px);\n  margin-left: -24px;\n  margin-right: -24px;\n  width: calc(100% + 48px);\n  background-color: var(--surface-neutral-white);\n}\n\n.heroIllustration {\n  background-color: var(--surface-neutral-pale, #f2f2f2);\n  position: relative;\n  overflow: hidden;\n  min-height: 840px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.heroImage {\n  width: 100%;\n  height: auto;\n  max-width: none;\n  flex-shrink: 0;\n  object-fit: contain;\n  pointer-events: none;\n}\n\n.contentPanel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--surface-neutral-white);\n  padding: var(--spacing-3);\n  gap: var(--spacing-3);\n}\n\n.contentCentered {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 350px;\n  gap: var(--spacing-3);\n}\n\n.headerSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 350px;\n  gap: var(--spacing-2);\n}\n\n.titleContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-2);\n}\n\n.headerIcon {\n  width: 32px !important;\n  height: 32px !important;\n  flex-shrink: 0;\n}\n\n.mainTitle {\n  font-size: 24px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  line-height: var(--line-height-100);\n  text-align: center;\n}\n\n.titleBold {\n  font-weight: var(--font-weight-bold);\n}\n\n.titleRegular {\n  font-weight: var(--font-weight-regular);\n}\n\n.subtitle {\n  font-size: 15px;\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-160);\n  align-self: center;\n  margin: 0;\n}\n\n.statusCard {\n  width: 350px;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--surface-neutral-white);\n}\n\n.timelineContainer {\n  padding: 0;\n}\n\n.compactTimeline {\n  --benefits-timeline-item-min-height: 32px;\n  --benefits-timeline-item-padding-bottom: 0px;\n  --benefits-timeline-connector-top: 16px;\n  --benefits-timeline-connector-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutRoot": `aRcrnT`,
	"heroIllustration": `FJTRwj`,
	"heroImage": `Qj8y7R`,
	"contentPanel": `FpybaY`,
	"contentCentered": `zFXSTX`,
	"headerSection": `ay8rJF`,
	"titleContainer": `UQ0zqK`,
	"headerIcon": `CRibl_`,
	"mainTitle": `bGA4j2`,
	"titleBold": `v67ek_`,
	"titleRegular": `JZnUHb`,
	"subtitle": `qiSExc`,
	"statusCard": `ATlYMt`,
	"timelineContainer": `HZ5kc4`,
	"compactTimeline": `lKm2Ib`
};
module.exports = ___CSS_LOADER_EXPORT___;
